<div class="container mt-3">
  <div class="card mb-3" style="max-width: 100%; background: transparent; border: none;">
    <div class="row no-gutters">
      <div class="col-md-4">
        <img src="{{ slika }}" class="card-img">
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <h2 class="card-title">{{ naziv }}</h2>
          <h5 class="card-title">{{ vrsta }}</h5>
          <p class="card-text">{{opis}}</p>
          <p class="card-text">CIJENA {{cijena}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
